import { IEventEditItem, EventEditItem } from "./eventEditItem";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { IdColorTitle, IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { IEventCompany, EventCompany } from "./eventCompany";
import { Base } from "ui/Scripts/source/framework/base";
import { IUnitItem, UnitItem } from "../unit/unitItem";
import { IEventTypeNode, EventTypeNode } from "./eventTypeNode";
import { EventSettingSimple, IEventSettingSimple } from "ui/Scripts/source/models/eventSettings/eventSettingSimple";

export interface IEventEdit {
    item: IEventEditItem;
    eventTypeNodes: IEventTypeNode[];
    eventTypeBNodes: IEventTypeNode[];
    eventTypeCNodes: IEventTypeNode[];
    attachments: IFileAttachment[];
    createCompany: IEventCompany;
    companies: IEventCompany[];
    units: IUnitItem[];
    urgencyClasses: IIdColorTitle[];
    eventSetting: IEventSettingSimple;
    userCompanyId: string;
    userCode: string;
    userName: string;
    userPicture: string;
    canHandleEvent: boolean;
    canRemoveEvent: boolean;
    canSaveEvent: boolean;
    canEditIdentificationData: boolean;
    userIsIsSystemAdmin: boolean;
}

export class EventEdit implements IEventEdit {
    item: EventEditItem;
    eventTypeNodes: EventTypeNode[];
    eventTypeBNodes: EventTypeNode[];
    eventTypeCNodes: EventTypeNode[];
    attachments: FileAttachment[];
    createCompany: EventCompany;
    companies: EventCompany[];
    units: UnitItem[];
    urgencyClasses: IdColorTitle[];
    eventSetting: EventSettingSimple;
    userCompanyId: string;
    userCode: string;
    userName: string;
    userPicture: string;
    canHandleEvent: boolean;
    canRemoveEvent: boolean;
    canSaveEvent: boolean;
    canEditIdentificationData: boolean;
    userIsIsSystemAdmin: boolean;

    constructor();
    constructor(obj: IEventEdit);
    constructor(obj?: any) {
        this.item = null;
        if (obj && obj.item) {
            this.item = new EventEditItem(obj.item);
        }
        this.userCompanyId = obj && obj.userCompanyId || "";
        this.userCode = obj && obj.userCode || "";
        this.userName = obj && obj.userName || "";
        this.userPicture = obj && obj.userPicture || "";
        this.canHandleEvent = obj && obj.canHandleEvent && obj.canHandleEvent === true;
        this.canRemoveEvent = obj && obj.canRemoveEvent && obj.canRemoveEvent === true;
        this.canSaveEvent = obj && obj.canSaveEvent && obj.canSaveEvent === true;
        this.canEditIdentificationData = obj && obj.canEditIdentificationData && obj.canEditIdentificationData === true;
        this.userIsIsSystemAdmin = obj && obj.userIsIsSystemAdmin && obj.userIsIsSystemAdmin === true;
        this.eventTypeNodes = Base.getTypedArray<EventTypeNode>(obj ? obj.eventTypeNodes : null, EventTypeNode);
        this.eventTypeBNodes = Base.getTypedArray<EventTypeNode>(obj ? obj.eventTypeBNodes : null, EventTypeNode);
        this.eventTypeCNodes = Base.getTypedArray<EventTypeNode>(obj ? obj.eventTypeCNodes : null, EventTypeNode);
        this.attachments = Base.getTypedArray<FileAttachment>(obj ? obj.attachments : null, FileAttachment);
        this.createCompany = new EventCompany(!Base.isNullOrUndefined(obj) ? obj.createCompany : null);
        this.companies = Base.getTypedArray<EventCompany>(obj ? obj.companies : null, EventCompany);
        this.units = Base.getTypedArray<UnitItem>(obj ? obj.units : null, UnitItem);
        this.urgencyClasses = Base.getTypedArray(obj ? obj.urgencyClasses : null, IdColorTitle);
        this.eventSetting = new EventSettingSimple(obj?.eventSetting);
    }
}